import { FC } from "react";
import './Entity.scss';

export type EntityType = 'organization' | 'contract' | 'user';

export type IEntity = {
  id: number,
  name: string,
  type: EntityType,
  avatar: string,
  description: string,
};

export type EntityProps = {
  entity: IEntity | null,
  handleClick?: (entity: IEntity | null) => void,
};

export const IconMap: Record<EntityType, string> = {
  'organization': '🏛️',
  'contract': '📜',
  'user': '👤',
};

const Entity: FC<EntityProps> = (props) => {

  return (
    <div className="entity-card flex-start" onClick={() => {if (props.handleClick) { props.handleClick(props.entity)}}}>
      <img src={props.entity?.avatar} />

      <div className="icon">
        { props.entity ? IconMap[props.entity.type] : '?' }
      </div>
      <div className="text">
        <p className="name">{props.entity?.name}</p>
        <p className="description">{props.entity?.description}</p>
      </div>
    </div>
  );
}

export default Entity;
